import React from 'react'

import PropTypes from 'prop-types'

/**
 * @typedef {Object} SideSpacesCompensatorProps
 * @property {string} [className] - Additional CSS class name
 * @property {React.ReactNode} children - Child elements to be rendered
 * @property {number} [size=1] - Size of the compensation in rem units
 */

/**
 * Component that compensates for side spaces by applying negative margins
 * @param {SideSpacesCompensatorProps} props
 * @returns {JSX.Element}
 */
const SideSpacesCompensator = ({ className, children, size = 1 }) => (
  <div className={className} style={{ marginLeft: `-${size}rem`, marginRight: `-${size}rem` }}>
    {children}
  </div>
)

SideSpacesCompensator.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.number,
}

export default SideSpacesCompensator
